import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import ServicesOverview from './components/ServicesOverview';
import ProjectsPreview from './components/ProjectsPreview';
import CommunityPreview from './components/CommunityPreview';
import TestimonialsSection from './components/TestimonialsSection';
import ProcessSection from './components/ProcessSection';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <ServicesOverview />
        <ProjectsPreview />
        <CommunityPreview />
        <TestimonialsSection />
        <ProcessSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
